import React, { useState, useEffect, useContext } from 'react';
import config from "./config.json";
import {
    List, Datagrid, TextField, FunctionField, SimpleList, useRefresh, usePermissions, Button as RaButton
} from 'react-admin';
import {
    useMediaQuery, makeStyles, FormControl, InputLabel, Select, MenuItem, Button, Paper, Typography, Avatar, TextField as MuiTextField, Dialog, DialogContent, DialogActions, CircularProgress
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import ParkingSearchSelector from "./components/ParkingSearchSelector";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import moment from 'moment';
import CustomFilter from './components/CustomFilter';
import ImageGalleryDialogV2 from './components/ImageGalleryDialogV2';
import ScrollableTable from './components/ScrollableTable';
import BrokenImageOutlinedIcon from '@material-ui/icons/BrokenImageOutlined';
import { io } from 'socket.io-client';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import { vehicleSvgs } from "./sharedData";
import CustomDateTimePicker from "./components/CustomDateTimePickerV4";
import { ContextProvider } from './globalContextProvider';
import notify from './components/CustomUseNotify';
import { hideVehicleNumber } from "./sharedData";
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import ShowTimePeriod from './components/ShowTimePeriod';
import Skeleton from '@material-ui/lab/Skeleton';
import queryString from 'query-string';
import downArrow from './images/down.png'
import sideArrow from './images/side.png'
// import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
// import { AnalyticDistributionImgs } from "./sharedData";
import CommentIcon from '@material-ui/icons/Comment';

const socket = io(`${config.HOST_NAME}`, { transports: ['websocket', 'polling', 'flashsocket'] })

const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
});

const renderActionForMob = action => {
    var color;
    switch (action) {
        case "ENTRY": color = customTheme.palette.primary.main; break;
        case "EXIT": color = customTheme.palette.error.main; break;
        default: color = customTheme.palette.secondary.main;
    }

    return <div style={{ color, display: "inline" }}>{action}</div>;
}

const renderAction = action => {
    var color;
    switch (action) {
        case "ENTRY": color = customTheme.palette.primary.main; break;
        case "EXIT": color = customTheme.palette.error.main; break;
        default: color = customTheme.palette.secondary.main;
    }

    return <div style={{ color }}>{action}</div>;
}

const CATEGORY = "VISITOR LOGS SECTION"

let visitorSummaryInitState = {
    "data": {
        "Entry": {
            "totalSum": 0
        },
        "Exit": {
            "totalSum": 0
        },
    },
    "message": "",
    "success": true,
    "loading": true,
    "isInitState": true
}
const defaultFilter = [
    {
        "filterType": "Log By",
        "value": "",
        "id": ""
    },
    {
        "filterType": "Log Type",
        "value": "",
        "id": ""
    },
    {
        "filterType": "Confidence",
        "value": "",
        "id": ""
    },
    {
        "filterType": "Other",
        "value": "",
        "id": ""
    }
];

export const VisitorLogs = props => {
    const eventTracker = UseAnalyticsEvent()
    const { showVisitorLogsLiveFeed, setShowVisitorLogsLiveFeed } = useContext(ContextProvider);
    const classes = useStyles();
    const location = useLocation();
    const [listData, setListData] = useState({})

    //const notify = useNotify();
    const refresh = useRefresh();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    let defaultImg = "https://images.parksmart.in/main/Images/ParkingImages/default_parking.jpg"

    const { permissions } = usePermissions();
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    const [showSurveillanceImages] = useState(sessionStorage.getItem("show_surveillance_images") === "1");
    const [showAnprRawImage] = useState(sessionStorage.getItem("show_anpr_raw_image") === "1");
    const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
    const [reduceSummary] = useState(isNaN(sessionStorage.getItem("reduce_summary")) || sessionStorage.getItem("reduce_summary") === '0' || sessionStorage.getItem("reduce_summary") === 0 ? '' : sessionStorage.getItem("reduce_summary"));
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});

    //    const [dialogVisible, setDialogVisible] = React.useState(false);
    const [parkingCount, setParkingCount] = React.useState(null);

    const [highLightRecordIds, setHighLightRecordIds] = useState({})
    const [isSurveillanceEntry, setisSurveillanceEntry] = useState(false);

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));


    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Vehicle Number", "Tag ID"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Vehicle Number");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : defaultFilter);
    const [allRecordsImage, setAllRecordImage] = useState([])
    let filterTypesInitState = [
        {
            filterType: "Log By",
            dataList: [{ name: "ANPR", id: 1 }, { name: "NON-ANPR", id: 2 }, { name: "BOTH JOINT", id: 3 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Log Type",
            dataList: [{ name: "ENTRY", id: 1 }, { name: "EXIT", id: 2 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Confidence",
            dataList: [],
            listType: "Static",
            caseType: "Static",
            filterFormat: "Range",
            showFilter: showAnprRawImage
        },
        {
            filterType: "Other",
            dataList: [{ name: "Live Feed", id: 1 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
    ]

    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
    const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
    const [visitorSummary, setVisitorSummary] = useState(visitorSummaryInitState)
    const [showTiles, setShowTiles] = useState(true)
    const [startDateTime, setStartDateTime] = useState(null);
    const [endDateTime, setEndDateTime] = useState(null);

    const filter = { ...settingFilterFormat, start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "", end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined, checkEntry: (isSurveillanceEntry && currentParking.id) || (!showFilter && isSurveillanceEntry) ? 1 : 0 };

    const renderTime = time => {
        const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if (use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY HH:mm${secondsFormat}`)
        return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY hh:mm${secondsFormat} A`)
	};

    const renderVehicleType = row => (
        row.vehicle_type ?
            <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
                <img src={vehicleSvgs[row.vehicle_type]} style={{ width: 25, height: 25, marginRight: 4 }} alt="Vehicle Icon" />
            </div>
            :
            "-"
    );

    const onParkingChange = (parking) => {
        if (parking == null) {
            setShowVisitorLogsLiveFeed(false)
            socket.close()
        }
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const postRowStyle = (record, index) => {
        return {
            backgroundColor: record && record.id === highLightRecordIds[record.id] ? '#18cc6919' : 'white',
            transition: "1s ease"
        };
    }

    const getVisitorSummary = () => {
        setVisitorSummary({ loading: true, data: visitorSummaryInitState.data, isInitState: true })
        const params = {
            filter: JSON.stringify({
                access_key_id: currentParking.id,
                parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined,
                start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
                end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : ""
            })
        }
        fetch(`${config.HOST_NAME}/crm/surveillance/tiles?${queryString.stringify(params)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        }).then(response => {
            saveTokens(response)
            return response.json()
        })
            .then(responseJson => {
                if (responseJson.success) setVisitorSummary({ loading: false, data: responseJson.data, isInitState: false });
                else notify(responseJson.message, 'warning');
            })
            .catch((e) => {
                console.log(e)
                notify('Error Fetching Summary', 'warning')
            });
    }

    useEffect(() => {
        if (!reduceSummary) {
            getVisitorSummary()
        }
    }, [currentParking, startDateTime, endDateTime, reduceSummary]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (Object.keys(listData).length !== 0) {
            setAllRecordImage((prev) => {
                let temp = [...Object.values(listData)]
                let images = temp.map((val) => val.img_url)
                return images.reverse()
            })
        }
    }, [listData])

    useEffect(() => {
        fetch(`${config.HOST_NAME}/crm/v3/getUserParkingsCount`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    setParkingCount(json.data)
                } else {
                    notify(json.message, 'warning');
                }
            })
            .catch((error) => {
                notify('Something went wrong', 'warning');
            });

    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (showVisitorLogsLiveFeed) {
            eventTracker(CATEGORY, "LIVE FEED ENABLE")
            socket.on('connnection', () => {
                console.log('connected to server');
            })
            if (typeof currentParking.id !== "undefined") {
                socket.on(`${currentParking.id}_VISITORS_LOG`, ({ inserted_log_id, vehicle_number, action }) => {
                    refresh()
                    setHighLightRecordIds((prev) => {
                        return { ...prev, [inserted_log_id]: inserted_log_id }
                    })
                    setTimeout(() => {
                        setHighLightRecordIds((prev) => {
                            const records = { ...prev };
                            delete records[inserted_log_id];
                            return records
                        })
                    }, 5000);
                })
            }
            if (parkingCount && parkingCount.count === 1 && parkingCount.parking_id) {
                socket.on(`${parkingCount.parking_id}_VISITORS_LOG`, ({ inserted_log_id, vehicle_number, action }) => {
                    refresh()
                    setHighLightRecordIds((prev) => {
                        return { ...prev, [inserted_log_id]: inserted_log_id }
                    })
                    setTimeout(() => {
                        setHighLightRecordIds((prev) => {
                            const records = { ...prev };
                            delete records[inserted_log_id];
                            return records
                        })
                    }, 5000);
                })
            }

            socket.on('message', (message) => {
                console.log(message);
            })

            socket.on('disconnect', () => {
                console.log('Socket disconnecting');
            })
        }

    }, [showVisitorLogsLiveFeed])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Log Type") {
                    values = { ...values, action_type: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Log By") {
                    values = { ...values, log_by: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Confidence") {
                    values = { ...values, confidence_range: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Other") {
                    if (filterListValue[val].value === 'Live Feed') {
                        setShowVisitorLogsLiveFeed(true)
                        refresh()
                    } else {
                        setShowVisitorLogsLiveFeed(false)
                        socket.close()
                    }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        if (!currentParking.id) {
            setisSurveillanceEntry(false)
        }
    }, [currentParking])

    React.useEffect(() => {
        eventTracker(CATEGORY, " VISITOR LOGS LIST")
        const defaultMinConfidence = sessionStorage.getItem("default_min_confidence");
        if (defaultMinConfidence !== "" && !isNaN(defaultMinConfidence)) {
            setFilterListValue(filterItems => {
                return filterItems.map(item => {
                    const copyItem = { ...item };
                    if (item.filterType === "Confidence") {
                        copyItem.value = `${defaultMinConfidence}-100`;
                    }
                    return copyItem;
                });
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <div className={classes.list}>

        <div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: isSmallDevice ? "0 16px" : 0 }}>
            {showFilter && <ParkingSearchSelector
                value={currentParking}
                onChange={onParkingChange}
                clearable={true}
                pathName={location.pathname}
            />}

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined">
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>

        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} />
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
            <ImageGalleryDialogV2 customButton={true} record={allRecordsImage} getImages={(record) => [...allRecordsImage]} />
            {/* {(parkingCount?.count === 1 || typeof currentParking?.id !== 'undefined') && <LiveFeed dialogVisible={dialogVisible} setDialogVisible={setDialogVisible} showVisitorLogsLiveFeed={showVisitorLogsLiveFeed} setShowVisitorLogsLiveFeed={setShowVisitorLogsLiveFeed} refresh={refresh} />} */}
            {sessionStorage.getItem('check_vehicle_exit') === "1" && ((currentParking && currentParking.id) || (!showFilter && permissions === 'contractor')) &&
                <Button
                    title='Check Surveillance Entry'
                    variant='contained'
                    disableElevation
                    size="small"
                    style={{ textTransform: "none", fontWeight: 500, color: isSurveillanceEntry ? "#F5F8FA" : '#334d6e', fontSize: 14, fontFamily: "Poppins-Regular", padding: "13px 20px", letterSpacing: "0.06em", borderRadius: 10, backgroundColor: isSurveillanceEntry ? '#334d6e' : "#F5F8FA" }}
                    onClick={() => setisSurveillanceEntry(!isSurveillanceEntry)}>
                    <DirectionsCarIcon style={{ fontSize: 20 }} />
                </Button>
            }
        </div>

        <ShowTimePeriod
            startDateTimeFilter={startDateTime}
            endDateTimeFilter={endDateTime}
            showTiles={reduceSummary ? false : showTiles}
            setShowTiles={reduceSummary ? null : setShowTiles}
        />

        {showTiles && !reduceSummary &&
            <>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", justifyContent: "space-between", gap: 15, marginTop: 10 }}>
                    {
                        Object.keys(visitorSummary.data).map((value) => (
                            <SummaryCard
                                title={value}
                                data={visitorSummary.data[value]["types"]}
                                getValue={data => visitorSummary.data[value]["totalSum"]}
                                // getDistributedLabels={data => Object.keys(data).map(val => AnalyticDistributionImgs[val]?.["label"])}
                                // getDistributedValues={data => Object.keys(data).map(val => data[val].count ? data[val].count : 0)}
                                // getDistributedIcons={data => Object.keys(data).map(val => AnalyticDistributionImgs[val]?.["img"])}
                                // getDistributedValuePercentage={data => Object.keys(data).map(val => data[val].percentage ? data[val].percentage : 0)}
                                // getDistributedPercentage={data => Object.keys(data).map((val, i) => {
                                //     return { percentage: data[val].percentage ? data[val].percentage.toFixed(2) : 0, color: progressBarColor[i] }
                                // })}
                                loading={visitorSummary.loading}
                            />
                        ))
                    }
                </div>
            </>
        }

        <List
            {...props}
            style={{ marginTop: 20 }}
            title="Visitor Logs"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            pagination={<CustomPagination setListData={(listData) => setListData(listData.data)} />}
            actions={false}
        >
            {
                isSmallDevice ?
                    <SimpleList
                        leftIcon={row => row.vehicle_type ? <Avatar src={vehicleSvgs[row.vehicle_type]} style={{ padding: 4, width: 28, height: 28, marginTop: 8, marginRight: 10, overflow: "visible" }} alt="Vehicle Icon" /> : undefined}
                        primaryText={record => hideVehicleNumber(record.vehicle_number)}
                        secondaryText={record => (<div>
                            {record.tag_id && <div><span style={{ color: "#5a5a5a" }}>Tag ID: </span>{record.tag_id}</div>}
                            {record.log_type && <div><span style={{ color: "#5a5a5a" }}>Action: </span>{renderActionForMob(record["log_type"])}</div>}
                            {record.controller_id && <div><span style={{ color: "#5a5a5a" }}>Controller ID: </span>{record.controller_id}</div>}
                            {record.description && <div><span style={{ color: "#5a5a5a" }}>Description: </span>{record.description}</div>}
                            {record.timestamp && <div><span style={{ color: "#5a5a5a" }}>Created On: </span>{renderTime(record["timestamp"])}</div>}
                            {record.parking_name && <div><span style={{ color: "#5a5a5a" }}>Parking Name: </span>{record.parking_name}</div>}
                            {record.remark && <div><span style={{ color: "#5a5a5a" }}>Remark: </span>{record.remark}</div>}
                            {!viewOnly && <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                <AddRemark {...props} record={record} />
                            </div>}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid className='visitorLogsDataGrid' component={ScrollableTable}>
                        <FunctionField
                            label="Image"
                            render={(record) => record.img_url ?
                                <ImageGalleryDialogV2
                                    thumbnail={true}
                                    thumbnailUrl={record.img_url_thumbnail}
                                    record={record}
                                    style={{ textAlign: "left" }}
                                    getImages={(record) => {
                                        let parkingImage = defaultImg;
                                        if (record.img_url) {
                                            return [record.img_url]
                                        } else {
                                            return [parkingImage]
                                        }
                                    }}
                                />
                                :
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #BDBDBD", minWidth: "50px", width: "60px", borderRadius: 5, height: "40px" }}>
                                    <BrokenImageOutlinedIcon />
                                </div>
                            }
                        />
                        <FunctionField source="vehicle_number" label="Vehicle Number / Tag ID" render={record => record && renderVehicleTagId(record)} />
                        <FunctionField source="vehicle_type" label="Type"render={record => record && renderVehicleType(record)}/>
                        <FunctionField source="log_type" label="Action" render={record => renderAction(record["log_type"])} />
                        <FunctionField source="controller_id" label="Controller ID" render={record => record && record.controller_id ? <p>{record.controller_id}</p> : <p>-</p>} />
                        <FunctionField source="description" label="Description" render={record => record && record.description ? <p>{record.description}</p> : <p>-</p>} />
                        {/* <TextField source='controller_id' label="Controller ID" />
                        <TextField source='description' label="Description" /> */}
                        <FunctionField source="timestamp" label="timestamp" render={record => renderTime(record["timestamp"])} />
                        <TextField source='parking_name' label="Parking Name" />
                        <TextField source='remark' label="Remark" />
                        {showAnprRawImage && <FunctionField
                            label="Raw Image"
                            render={(record) => record.raw_image_url ?
                                <ImageGalleryDialogV2
                                    thumbnail={true}
                                    thumbnailUrl={record.raw_image_url_thumbnail}
                                    record={record}
                                    style={{ textAlign: "left" }}
                                    getImages={(record) => {
                                        let parkingImage = defaultImg;
                                        if (record.raw_image_url) {
                                            return [record.raw_image_url]
                                        } else {
                                            return [parkingImage]
                                        }
                                    }}
                                />
                                :
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #BDBDBD", minWidth: "50px", width: "60px", borderRadius: 5, height: "40px" }}>
                                    <BrokenImageOutlinedIcon />
                                </div>
                            }
                        />}
                        {showAnprRawImage && <TextField source='confidence' label="Confidence" />}
                        {showAnprRawImage && <TextField source='bounding_box' label="Bounding Box" />}
                        {(permissions === "admin" || showSurveillanceImages) && <FunctionField
                            label="Other Images"
                            render={(record) => {
                                const BrokenImage = <div style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #BDBDBD", minWidth: "50px", width: "60px", borderRadius: 5, height: "40px" }}>
                                    <BrokenImageOutlinedIcon />
                                </div>;
                                if (typeof record.other_images === "string" && record.other_images !== "") {
                                    try {
                                        const otherImages = JSON.parse(record.other_images);
                                        if (Array.isArray(otherImages) && otherImages.length > 0) {
                                            return <ImageGalleryDialogV2
                                                thumbnail={true}
                                                thumbnailUrl={record.img_url_thumbnail}
                                                record={record}
                                                style={{ textAlign: "left" }}
                                                getImages={record => typeof record.img_url === "string" && record.img_url !== "" ? otherImages.concat([record.img_url]) : otherImages}
                                                showMultipleThumbnails={true}
                                            />
                                        } else {
                                            return BrokenImage;
                                        }
                                    } catch (err) {
                                        return BrokenImage;
                                    }
                                } else {
                                    return BrokenImage;
                                }
                            }}
                        />}
                        {!viewOnly && <FunctionField className="ListIconsContainerVisitorLogs" render={record => record &&
                            <div className="ListIcons">
                                <div>
                                    <AddRemark {...props} record={record} />
                                </div>
                            </div>
                        } />}
                    </Datagrid>
            }
        </List>
    </div>
};

const renderVehicleTagId = (record) => {
    if (record.vehicle_number && record.tag_id) {
        return <div>
            <p style={{ lineHeight: "3px", color: "#334d6e", fontWeight: "bold" }}>{hideVehicleNumber(record.vehicle_number)}</p>
            <p style={{ lineHeight: "3px", color: "#BDBDBD", fontSize: 10 }}>{record.tag_id}</p>
        </div>
    }
    if (record.vehicle_number && !record.tag_id) {
        return <p style={{ lineHeight: "3px", color: "#334d6e", fontWeight: "bold" }}>{hideVehicleNumber(record.vehicle_number)}</p>
    }
    if (!record.vehicle_number && record.tag_id) {
        return <p style={{ lineHeight: "3px", color: "#334d6e", fontWeight: "bold" }}>{record.tag_id}</p>
    }
}

function SummaryCard({ title, loading, data, getValue, getDistributedValues, getDistributedLabels, getDistributedIcons, getDistributedPercentage, getDistributedValuePercentage, getSubPercentage, getDistributedAmount, showDonutChart, clickable, showProgressBar = false, getDistributedCount, showTooltip = false, getNestedTypes = null, isPaymentType = true, activityType, setActivityType, style }) {
    const classes = useStyles();

    return <Paper style={{ position: "relative", display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px 18px 20px", cursor: clickable ? "pointer" : "", ...style }}>
        <div style={{ flex: 1 }}>
            <div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography className={classes.title} style={{ textTransform: "capitalize" }}>{title}</Typography>

                    {getValue(data) > 0 && setActivityType &&
                        <Button style={{ minWidth: "80px", background: "none", border: "none", cursor: "pointer", backgroundColor: "#109CF11A", color: "#5E8DD3", padding: "1px 12px", borderRadius: 2, fontSize: 9, textTransform: "none", fontWeight: "normal" }} onClick={() => setActivityType(activityType === title && activityType ? null : activityType === null ? title : activityType && activityType !== title ? title : null)}><p style={{ lineHeight: 0, marginRight: 5 }}>{activityType === title ? "Details" : "Gate Wise Filter"}</p>
                            <img src={activityType === title ? downArrow : sideArrow} alt='arrow' />
                        </Button>
                    }
                </div>
                {
                    !loading && data ?
                        <div style={{ display: "flex", gap: 10, alignItems: getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) ? "center" : "", flexWrap: "wrap" }}>
                            {getDistributedCount && getDistributedCount(data) && <Typography className={classes.mainValue} style={{ color: "#334D6E", marginRight: 10 }}>{getDistributedCount(data)}</Typography>}
                            <Typography className={classes.mainValue}>{["Amount"].includes(title) || ["Amount"].includes(activityType) ? "₹" : ""} {getValue(data)}</Typography>
                            {getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) &&
                                <div style={{ display: "flex", alignItems: "center", backgroundColor: "#18CC6919", fontSize: 9, color: "#18CC69", padding: "0px 10px", height: 15, borderRadius: 10, fontFamily: "Poppins-SemiBold" }}>
                                    {getSubPercentage(data)}%
                                </div>
                            }
                        </div>
                        :
                        !loading && !data ?
                            <div style={{ display: "flex", gap: 10, alignItems: getSubPercentage && (getSubPercentage(data) || getSubPercentage(data) === 0) ? "center" : "", flexWrap: "wrap" }}>
                                <Typography className={classes.mainValue}>{["Amount"].includes(title) || ["Amount"].includes(activityType) ? "₹" : ""} {getValue(data) ? getValue(data) : 0}</Typography>
                            </div>
                            :
                            <Skeleton variant="text" height={25} width="100px" />
                }
            </div>
            {/* {
                !loading && data ? getDistributedLabels(data).map((dL, i) => (
                    <div>
                        <div key={dL} className={classes.flexContainer}>
                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                <img className={classes.summaryVehicleIcon} src={getDistributedIcons(data)[i]} alt={dL} />
                                <Typography className={classes.summaryBoxLabel1}>{dL}:</Typography>
                            </div>
                            <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 10, flexWrap: "wrap" }}>
                                <Typography className={classes.summaryBoxValue1}>{["Amount"].includes(title) || ["Amount"].includes(activityType) ? "₹" : ""} {getDistributedValues(data)[i]}</Typography>

                                {isPaymentType && getDistributedAmount && getDistributedAmount(data) && <>
                                    <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69" }}>₹ {getDistributedAmount(data)[i].toFixed(2)}</Typography>                            </>
                                }
                                {!["Manual"].includes(dL) && getDistributedValuePercentage && getDistributedValuePercentage(data) && <>
                                    <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69", fontSize: 9 }}>{getDistributedValuePercentage(data)[i].toFixed(2)}%</Typography>
                                    {showTooltip && <Tooltip arrow title={`This percentage is the overall share for this gate for ${dL}`} classes={{ tooltip: classes.tooltip }}><InfoOutlinedIcon style={{ fontSize: 12, color: "#888" }} /></Tooltip>}
                                </>
                                }
                            </div>
                        </div>

                        {getNestedTypes && getNestedTypes(data) !== null &&
                            [Object.keys(getNestedTypes(data))[i]].map((val) => (
                                <>
                                    {getNestedTypes(data)[val]["types"] && Object.keys(getNestedTypes(data)[val]["types"]).map((subType) => (
                                        <div key={subType} className={classes.flexContainer} style={{ marginLeft: 20 }}>
                                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
                                                <img className={classes.summaryVehicleIcon} src={AnalyticDistributionImgs[subType]?.["img"]} alt={subType} />
                                                <Typography className={classes.summaryBoxLabel1}>{subType}:</Typography>
                                            </div>
                                            <div style={{ flex: 1, display: "flex", justifyContent: "flex-end", alignItems: "flex-end", gap: 10, flexWrap: "wrap" }}>
                                                <Typography className={classes.summaryBoxValue1}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["count"] ? `${getNestedTypes(data)[val]["types"][subType]["count"]}` : '0'} </Typography>
                                                {isPaymentType && <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69" }}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["amount"] ? `₹ ${getNestedTypes(data)[val]["types"][subType]["amount"].toFixed(2)}` : '₹ 0'} </Typography>}
                                                <Typography className={classes.summaryBoxValue1} style={{ color: "#18CC69", fontSize: 9 }}>{getNestedTypes(data)[val]["types"] && getNestedTypes(data)[val]["types"][subType]["percentage"] ? getNestedTypes(data)[val]["types"][subType]["percentage"].toFixed(2) : '0'}%</Typography>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            ))
                        }


                    </div>
                )) :
                    !loading && !data ? null
                        :
                        ["50", "40"].map((width, index) => (
                            <Skeleton variant="text" width={width} height={18} key={index} />
                        ))
            } */}
        </div>

        {/* {showProgressBar && data && getDistributedPercentage &&
            <div className="horizontal-bar" style={{ position: "absolute", bottom: 0, left: 0, width: "100%" }}>
                {getDistributedPercentage(data).map((item, index) => (
                    <Tooltip arrow title={`${item.percentage}%`} classes={{ tooltip: classes.tooltip }}>
                        <div key={index} className="bar-segment" style={{ width: `${item.percentage}%`, backgroundColor: item.color }}>
                        </div>
                    </Tooltip>
                ))}
            </div>
        } */}
    </Paper>

}

function AddRemark(props) {
    const refresh = useRefresh();
    const { record } = props;

    const [dialogVisible, setDialogVisible] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [remark, setRemark] = React.useState("");

    const openDialog = e => {
        e.stopPropagation();
        setDialogVisible(true);
        if(record) setRemark(record?.remark || "")
    };

    const closeDialog = () => {
        setDialogVisible(false);
        setRemark("")
    };

    const addRemarkHandler = (event) => {
        event.preventDefault();
        // if (!remark) {
        //     notify("Remark is required", 'warning');
        //     return;
        // }

        setLoading(true);
        const data = {
            log_id: record.id,
            log_source: record.log_source,
            remark: remark
        };
        fetch(`${config.HOST_NAME}/crm/v3/saveVisitorLogRemark`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(responseJson => {
                setLoading(false);
                if (responseJson.success) {
                    refresh();
                    notify(responseJson.message, "success");
                    closeDialog();
                } else {
                    notify(responseJson.message, 'warning');
                }
            })
            .catch((e) => {
                setLoading(false);
                closeDialog();
                notify('Something went wrong', 'warning')
            });
    };

    useEffect(() => {
      if(record) setRemark(record?.remark || "")
    }, [record])

    return (
        <div style={{ textAlign: "center" }}>
            <RaButton onClick={openDialog} title="Add Remark" label={false}>
                <CommentIcon />
            </RaButton>
            <Dialog fullWidth open={dialogVisible}>
                <Typography style={{ fontSize: 19, fontWeight: "bold", padding: "16px 24px" }}>Add Remark</Typography>
                <DialogContent style={{ display: "grid", gridRowGap: 20 }}>
                    <MuiTextField
                        variant="outlined"
                        size="small"
                        label="Remark"
                        value={remark}
                        onChange={(event) => setRemark(event.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDialog} disabled={loading}>Cancel</Button>
                    <Button color="primary" onClick={addRemarkHandler} disabled={loading}>{loading ? "Saving..." : "Save"} {loading && <CircularProgress color="inherit" size={14} style={{ marginLeft: 15 }} />}</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

// const LiveFeed = ({ dialogVisible, setDialogVisible, showVisitorLogsLiveFeed, setShowVisitorLogsLiveFeed, refresh }) => {
//     const classes = useStyles()

//     const openDialog = () => {
//         setDialogVisible(true);
//     };

//     const closeDialog = () => {
//         setDialogVisible(false);
//     };

//     return (
//         <div>
//             {/* <Switch disabled={props.disabled} checked={Boolean(record.enabled)} onChange={openDialog} /> */}
//             {/* <IconButton style={{ color: "#18cc69" }} onClick={openDialog} disabled={showVisitorLogsLiveFeed}><AutorenewIcon style={{ fontSize: "12px" }} /></IconButton> */}
//             <Button
//                 variant='contained'
//                 color="secondary"
//                 disableElevation
//                 size="small"
//                 style={{ textTransform: "none", fontWeight: 500, color: showVisitorLogsLiveFeed ? "#18cc69" : '#334d6e', fontSize: 14, fontFamily: "Poppins-Regular", padding: "13px 20px", letterSpacing: "0.06em", borderRadius: 10, backgroundColor: "#F5F8FA" }}
//                 onClick={openDialog}>
//                 <AutorenewIcon style={{ fontSize: 20 }} />
//             </Button>
//             <Dialog open={dialogVisible} onClose={closeDialog} classes={{ paper: classes.dialogPaper }}>
//                 <DialogContent>
//                     {showVisitorLogsLiveFeed ?
//                         <p style={{ fontSize: 14 }}>Are you sure you want to <strong>Disable</strong> Auto Refresh</p>
//                         :
//                         <p style={{ fontSize: 14 }}>Are you sure you want to <strong>Enable</strong> Auto Refresh</p>
//                     }
//                 </DialogContent>
//                 <DialogActions>
//                     <Button onClick={closeDialog} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
//                         No
//                     </Button>
//                     <Button onClick={() => {
//                         if (showVisitorLogsLiveFeed) {
//                             setShowVisitorLogsLiveFeed(false)
//                             socket.close()
//                         }
//                         else {
//                             setShowVisitorLogsLiveFeed(true)
//                             refresh()
//                         }
//                         closeDialog()
//                     }} variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#18cc69", color: "#FFF" }} disableElevation>
//                         Yes
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//         </div >
//     );
// }
